/* ui.jsx — shared Cabin Pinochle components */
import React, { useState } from 'react';
import { THEMES, getTheme, nextTheme } from '../lib/theme.js';

// ── icons (line style) ──
export function Icon({ name, size = 22, stroke = 'currentColor', sw = 2, fill = 'none', style }) {
  const p = { fill, stroke, strokeWidth: sw, strokeLinecap: 'round', strokeLinejoin: 'round' };
  const paths = {
    home: <><path {...p} d="M3 11l9-7 9 7" /><path {...p} d="M5 10v9a1 1 0 001 1h12a1 1 0 001-1v-9" /></>,
    roster: <><circle {...p} cx="9" cy="8" r="3.2" /><path {...p} d="M3.5 19c0-3 2.5-5 5.5-5s5.5 2 5.5 5" /><path {...p} d="M16 6.5a3 3 0 010 5.4M17 14.2c2.4.6 4 2.5 4 4.8" /></>,
    cards: <><rect {...p} x="3" y="6" width="11" height="14" rx="2" /><path {...p} d="M8 10l3 3-3 3" fill="none" /><path {...p} d="M9.5 4.5l8 2.4a2 2 0 011.4 2.5l-2.5 9" /></>,
    trophy: <><path {...p} d="M7 4h10v4a5 5 0 01-10 0V4z" /><path {...p} d="M7 5H4v2a3 3 0 003 3M17 5h3v2a3 3 0 01-3 3" /><path {...p} d="M12 13v3M9 20h6M10 20l.5-4M14 20l-.5-4" /></>,
    plus: <><path {...p} d="M12 5v14M5 12h14" /></>,
    back: <path {...p} d="M15 5l-7 7 7 7" />,
    qr: <><rect {...p} x="3.5" y="3.5" width="6" height="6" rx="1" /><rect {...p} x="3.5" y="14.5" width="6" height="6" rx="1" /><rect {...p} x="14.5" y="3.5" width="6" height="6" rx="1" /><path {...p} d="M14.5 14.5h3v3M20.5 17.5v3M14.5 20.5h3" /></>,
    pin: <><rect {...p} x="4" y="9" width="16" height="11" rx="2.5" /><path {...p} d="M8 9V6.5a4 4 0 018 0V9" /><circle cx="12" cy="14.5" r="1.4" fill={stroke} stroke="none" /></>,
    edit: <><path {...p} d="M4 20h4l10-10-4-4L4 16v4z" /><path {...p} d="M13.5 6.5l4 4" /></>,
    swap: <><path {...p} d="M7 7h11l-3-3M17 17H6l3 3" /></>,
    check: <path {...p} d="M5 12.5l4.5 4.5L19 7" />,
    x: <path {...p} d="M6 6l12 12M18 6L6 18" />,
    chevron: <path {...p} d="M9 5l7 7-7 7" />,
    lock: <><rect {...p} x="5" y="11" width="14" height="9" rx="2" /><path {...p} d="M8 11V8a4 4 0 018 0v3" /></>,
    sparkle: <><path {...p} d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8L12 3z" /></>,
    gear: <><circle {...p} cx="12" cy="12" r="3.2" /><path {...p} d="M12 3v2.5M12 18.5V21M21 12h-2.5M5.5 12H3M18.4 5.6l-1.8 1.8M7.4 16.6l-1.8 1.8M18.4 18.4l-1.8-1.8M7.4 7.4L5.6 5.6" /></>,
    share: <><circle {...p} cx="6" cy="12" r="2.5" /><circle {...p} cx="17" cy="6" r="2.5" /><circle {...p} cx="17" cy="18" r="2.5" /><path {...p} d="M8.2 10.8l6.6-3.6M8.2 13.2l6.6 3.6" /></>,
    info: <><circle {...p} cx="12" cy="12" r="9" /><path {...p} d="M12 11v5M12 7.6v.2" /></>,
    cal: <><rect {...p} x="3.5" y="5" width="17" height="16" rx="2.5" /><path {...p} d="M3.5 9.5h17M8 3v3.5M16 3v3.5" /></>,
    map: <><path {...p} d="M12 21s7-6.2 7-11a7 7 0 00-14 0c0 4.8 7 11 7 11z" /><circle {...p} cx="12" cy="10" r="2.3" /></>,
    flag: <><path {...p} d="M6 21V4M6 4h11l-2 3.5L17 11H6" /></>,
    bolt: <path {...p} d="M13 3L5 13h6l-1 8 8-10h-6l1-8z" />,
    users: <><circle {...p} cx="8" cy="9" r="3" /><circle {...p} cx="16.5" cy="9.5" r="2.4" /><path {...p} d="M3 19c0-2.8 2.2-5 5-5s5 2.2 5 5M14 14.4c2.4 0 4 1.8 4 4.6" /></>,
    minus: <path {...p} d="M5 12h14" />,
    reset: <><path {...p} d="M4 12a8 8 0 108-8 8 8 0 00-6 2.7L4 9" /><path {...p} d="M4 4v5h5" /></>,
    warn: <><path {...p} d="M12 3.5L21 19H3L12 3.5z" /><path {...p} d="M12 10v4" /><circle cx="12" cy="16.6" r="0.6" fill={stroke} stroke="none" /></>,
    palette: <><path {...p} d="M12 21a9 9 0 010-18 8 8 0 018 8c0 2-1.2 3-3 3h-2.2c-1 0-1.5.9-.9 1.7.5.7.1 1.7-1 1.9-.3 0-.6.1-.9.1z" /><circle cx="8.2" cy="10.2" r="1.15" fill={stroke} stroke="none" /><circle cx="11.7" cy="7.3" r="1.15" fill={stroke} stroke="none" /><circle cx="15.3" cy="10.2" r="1.15" fill={stroke} stroke="none" /></>,
  };
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" style={style} aria-hidden="true">
      {paths[name]}
    </svg>
  );
}

// ── date ──
// Tournament dates are stored as ISO 'YYYY-MM-DD' (schemaVersion 1); render them
// as "Sat, Jul 4 2026". Pre-picker docs hold free text — pass those through as-is.
export function fmtDate(date) {
  if (!date) return '';
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(date);
  if (!m) return date;
  const d = new Date(+m[1], +m[2] - 1, +m[3]); // local time, not UTC-shifted
  return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' }).replace(/,(?=\s\d{4}$)/, '');
}

// today as ISO YYYY-MM-DD in the device's timezone (toISOString would be UTC-shifted)
export function todayISO() {
  return new Date().toLocaleDateString('en-CA');
}

// ── avatar ──
export function initials(name) {
  if (!name || !name.trim()) return '?';
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  // skip a leading honorific so "Aunt Rose" -> "R", "Uncle Dale" -> "D"
  const skip = /^(aunt|uncle|grandpa|grandma|cousin|pap|nana)$/i;
  const useful = parts.filter((w) => !skip.test(w));
  const src = useful.length ? useful : parts;
  return (src[0][0] + (src[1] ? src[1][0] : src[0][1] || '')).toUpperCase();
}

export function Avatar({ player, size = 38 }) {
  return (
    <div className="avatar" style={{ width: size, height: size, background: player.color, fontSize: size * 0.38 }}>
      {initials(player.name)}
    </div>
  );
}

// ── new-player flag (display only — shows nothing for regular players) ──
export function Flag({ isNew }) {
  if (!isNew) return null;
  return <span className="chip chip-new"><span className="pip" />New player</span>;
}

// ── tappable new-player toggle for editable rosters ──
export function NewToggle({ isNew, onClick }) {
  return (
    <button onClick={onClick} title="Tap to flag a new player"
      style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}>
      {isNew
        ? <span className="chip chip-new"><span className="pip" />New player</span>
        : <span className="chip chip-ghost">Flag new</span>}
    </button>
  );
}

// ── button ──
export function Btn({ kind = 'primary', sm, block, icon, children, onClick, disabled, style }) {
  const cls = ['btn', 'btn-' + kind, sm && 'btn-sm', block && 'btn-block'].filter(Boolean).join(' ');
  return (
    <button className={cls} onClick={onClick} disabled={disabled} style={style}>
      {icon && <Icon name={icon} size={sm ? 16 : 19} />}
      {children}
    </button>
  );
}

// ── theme toggle: a per-device look (localStorage), tap cycles through THEMES ──
export function ThemeToggle({ size = 40 }) {
  const [theme, setThemeState] = useState(getTheme());
  const label = THEMES.find((t) => t.id === theme)?.label || theme;
  return (
    <button className="topbar-btn" style={{ width: size, height: size }}
      title={`Theme: ${label} — tap to switch`}
      onClick={() => setThemeState(nextTheme().id)}>
      <Icon name="palette" size={size <= 32 ? 16 : 18} />
    </button>
  );
}

// ── card ──
export function Card({ wood, pad = true, children, style, className = '', onClick }) {
  return (
    <div className={(wood ? 'card-wood' : 'card') + (pad ? ' card-pad' : '') + ' ' + className} style={style} onClick={onClick}>
      {children}
    </div>
  );
}

// ── section label ──
export function SecLabel({ icon, children, right }) {
  return (
    <div className="sec-label">
      {icon && <Icon name={icon} size={15} stroke="var(--copper-600)" />}
      {children}
      {right}
    </div>
  );
}
